import * as React from 'react';
import { useTranslation } from 'react-i18next';
import type { GuitarSettings } from '../../../../../context/TranscriptionDialogContext/TranscriptionDialogContext';
import { TranscriptionDialogContext } from '../../../../../context/TranscriptionDialogContext/TranscriptionDialogContext';
import SelectionComponent from './SelectionComponent';

export interface GuitarStyleProps {
  setCurrentStep: (step: number) => void;
}

const GuitarStyle: React.FC<GuitarStyleProps> = ({ setCurrentStep }) => {
  const { t } = useTranslation();
  const { setSettings, settings } = React.useContext(TranscriptionDialogContext);
  const handleClick = (style: Partial<GuitarSettings['style']>) => {
    setSettings({ style: style ?? 'finger_picking' }, settings.instruments[0]);
    setCurrentStep(4);
  };

  const answers = [
    { title: t('home.input.dialog.style_guitar.strumming'), key: 'strumming' },
    { title: t('home.input.dialog.style_guitar.finger_picking'), key: 'finger_picking' },
    { title: t('home.input.dialog.unknown'), key: null },
  ];
  return <SelectionComponent answers={answers} handleClick={handleClick} id="style_guitar" />;
};

export default GuitarStyle;
